var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.otherIds.length > 0)?_c('b-alert',{attrs:{"variant":"warning","show":""}},[_vm._v("\n    Dit kenmerk is al in gebruik bij de volgende documenten: "+_vm._s(_vm.otherIds.join(', '))+"\n  ")]):_c('b-alert',{attrs:{"variant":"success","show":""}},[_vm._v("\n    Document kenmerk is uniek\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }